export enum SalesRouteDefinitionStatusType {
    ACTIVE = 'ffd484de-cd2f-4084-81f8-273eb66aae3b',
    PASSIVE = '8f6d72a3-081b-4a93-98f5-324ffd522fba',
}

export enum RevenueInterval {
  MIN = 0,
  MAX = 2147483647,
}
